import React from 'react';

// 地址。定位標記。跟導航路徑那個橘色標記形狀不同，不會混淆。
const IconLocation = ({ onClick }) => {
	return (
		<div className='IconLocation' onClick={onClick}>
			<svg
				width='20'
				height='20'
				viewBox='0 0 24 24'
				fill='none'
				stroke='#333333'
				strokeWidth='1.6'
				strokeLinecap='round'
				strokeLinejoin='round'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path d='M12 21.2c4.2-4.2 6.4-7.4 6.4-10.2a6.4 6.4 0 1 0-12.8 0c0 2.8 2.2 6 6.4 10.2Z' />
				<circle cx='12' cy='10.6' r='2.4' />
			</svg>
		</div>
	);
};

export default IconLocation;
